/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 14:07:12
 * @Description: 完善资料 index
 */
import PerfectInfo from "./perfectInfo";
export { PerfectInfo };
